import { useEffect, useRef } from 'react';
import { NaverLogin, NaverMobileLogin } from '../../assets';
import LoginNaver from 'react-login-by-naver';
import SocialLoginBtn from './SocialLoginBtn';
import { SocialLoginPlatformEnum } from './type';
import {
  clearNaverAccessTokenHash,
  completeNaverRedirectLogin,
  getNaverCallbackUrl,
  getNaverClientId,
  hasNaverAccessTokenHash,
  isNaverRedirectDelivered,
  markNaverRedirectDelivered,
} from '../../utils/naverCallback';

export default function NaverLoginBtn({
  afterSocialLoginSuccess,
  dataSocial,
  variant = 'legacy',
  recentLogin,
}) {
  const isRecent = variant === 'draft' && recentLogin === dataSocial;
  const callbackUrl = getNaverCallbackUrl();
  const clientId = getNaverClientId();
  const onSuccessRef = useRef(afterSocialLoginSuccess);
  onSuccessRef.current = afterSocialLoginSuccess;
  const isRedirectReturn = hasNaverAccessTokenHash();

  /**
   * 모바일은 팝업 대신 `/auth#access_token=` 으로 전체 이동한다.
   * 이 때 LoginNaver(isPopup:true)를 다시 init 하면 토큰을 소모하고 로그인은 안 끝난다.
   */
  useEffect(() => {
    if (!isRedirectReturn) return undefined;

    let active = true;
    completeNaverRedirectLogin().then((user) => {
      if (!active || isNaverRedirectDelivered()) return;
      clearNaverAccessTokenHash();
      if (!user?.id) {
        window.dispatchEvent(new Event('naver-redirect-settled'));
        return;
      }
      markNaverRedirectDelivered();
      onSuccessRef.current({
        type: SocialLoginPlatformEnum.NAVER,
        socialId: user.id,
        email: user.email,
      });
    });

    return () => {
      active = false;
    };
  }, [isRedirectReturn]);

  if (isRedirectReturn) {
    return null;
  }

  return (
    <div
      data-social={dataSocial}
      className={isRecent ? 'login-social-wrap--recent' : undefined}
    >
      <LoginNaver
        clientId={clientId}
        callbackUrl={callbackUrl}
        render={(props) => (
          <>
            <SocialLoginBtn
              onClick={props.onClick}
              backgroundColor="bg-[#03C75A]"
              fontColor="text-white"
              additionalStyle={undefined}
              icon={
                variant === 'draft' ? (
                  <NaverLogin width={24} height={24} />
                ) : (
                  <>
                    <NaverLogin className="hidden md:block" width={24} />
                    <NaverMobileLogin className="block md:hidden" />
                  </>
                )
              }
              text="naver"
              variant={variant}
            />
          </>
        )}
        onSuccess={(result) => {
          afterSocialLoginSuccess({
            type: SocialLoginPlatformEnum.NAVER,
            socialId: result.id,
            email: result.email,
          });
        }}
        onFailure={() => console.error('failed')}
      />
    </div>
  );
}
